import { ConflictError } from "./conflict-error";

// Thrown when the zone scanned to confirm a transport leg is not one of that leg's two ends.
//
// A leg runs from one zone to another, and the scan is what attests to where the person holding
// the box is standing. Nothing else in the yard can: before this check the server took the leg's
// own destination as the truth, so a box scanned anywhere was recorded as having arrived where it
// was heading — a claim the physical warehouse would never contradict.
//
// So the zone has to be the leg's origin or its destination, and which of the two it is decides
// what the scan means. Anything else is this refusal, and it carries the zone the leg is waiting
// at in the body so the app can say where to go rather than only that the scan was wrong. 409: the
// code is a real zone label and the caller may read it, and what is wrong is where they are
// standing.
export class WrongWarehouseZoneError extends ConflictError {
	constructor(
		/** The zone this leg's next transition happens in, for the message the app renders. */
		readonly expectedZoneName: string | null = null,
	) {
		super("stock.wrong_warehouse_zone", { body: { expectedZoneName } });
		this.name = "WrongWarehouseZoneError";
	}
}
